import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Loader2, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import AgreementsStep from "@/components/checkout/AgreementsStep";
import { useState } from "react";

export default function BookingAgreementsSign() {
  const { token } = useParams();
  const [finished, setFinished] = useState(false);
  const { data, isLoading, isError } = useQuery({
    queryKey: ["booking-agreements", token],
    queryFn: () => api.get(`/public/booking-agreements/${token}`).then((r) => r.data),
    retry: false,
  });
  const b = data?.booking;
  return (
    <div className="min-h-[70vh] px-4 py-10 sm:py-16" data-testid="booking-agreements-page">
      <div className="eyw-card max-w-xl mx-auto p-5 sm:p-8">
        {isLoading ? <Loader2 className="animate-spin text-[#144F75] mx-auto" />
          : isError ? <p className="text-[#B5794E]" data-testid="booking-agreements-invalid">This signing link is invalid or has expired.</p>
          : (
            <>
              <p className="text-sm text-[#4A5D6B] mb-4" data-testid="booking-agreements-summary">
                <b className="text-[#1A242B]">{b.service_title}</b> · {b.date} at {b.start_time}{b.location ? ` · ${b.location}` : ""}
              </p>
              {finished || !data.pending.length ? (
                <div className="text-center py-6" data-testid="booking-agreements-complete">
                  <CheckCircle2 size={44} className="text-[#5C8A72] mx-auto mb-3" />
                  <h1 className="font-serif text-2xl text-[#1A242B]">You're all set</h1>
                  <p className="text-sm text-[#4A5D6B] mt-2">Your agreements are signed and saved. Your booking is no longer on hold.</p>
                  <Link to="/" className="eyw-btn mt-6 inline-flex">Back to home</Link>
                </div>
              ) : (
                <AgreementsStep token={token} initialPending={data.pending} defaultName={b.name} onDone={() => setFinished(true)} />
              )}
            </>
          )}
      </div>
    </div>
  );
}
